import axios from 'axios'

export default class CountriesHelper {
    
    getCountries() {
        return axios.get('/data/countries.json').then(res => res.data.data)
        .catch(() => 
        alert("countries file missing"));
    }
} 